"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _checkTypes = _interopRequireDefault(require("check-types"));

var _Colors = require("../00_environment/Colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ListSelect = function ListSelect(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? {} : _ref$items,
      _ref$selectedItem = _ref.selectedItem,
      selectedItem = _ref$selectedItem === void 0 ? null : _ref$selectedItem,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {} : _ref$onSelect,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator;

  if (!_checkTypes["default"].nonEmptyArray(items)) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
      placeholder: true
    }, t('No choices available'));
  }

  var notSelectedMark = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 20
    }
  });

  var selectedMark = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 20,
      height: '100%',
      textAlign: 'left',
      color: _Colors.primaryColor,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
    name: "check",
    size: "small"
  }));

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment.Group, null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Segment, {
      key: item.key,
      onClick: function onClick() {
        return onSelect(item.value);
      },
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
      }
    }, item.value === selectedItem ? selectedMark : notSelectedMark, /*#__PURE__*/_react["default"].createElement("span", null, item.text || item.name || item.value));
  }));
};

var _default = ListSelect;
exports["default"] = _default;